module.exports = __webpack_public_path__ + "static/travelers-df034d3747c508a9a8532dcc8146f1dd.png";